import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates password complexity: at least one uppercase, lowercase, digit, and special character.
 * Returns specific error keys for each failing criterion.
 */
export const passwordComplexityValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value as string;

  if (!value) {
    return null; // let required validator handle empty values
  }

  const errors: ValidationErrors = {};

  if (!/[A-Z]/.test(value)) {
    errors['missingUppercase'] = true;
  }
  if (!/[a-z]/.test(value)) {
    errors['missingLowercase'] = true;
  }
  if (!/[0-9]/.test(value)) {
    errors['missingDigit'] = true;
  }
  if (!/[^A-Za-z0-9]/.test(value)) {
    errors['missingSpecialChar'] = true;
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
